import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, ActivityService, $stateParams, UserService, $filter, InsuranceSuiteMetadata, CancellationService, UserInfoService) => {
    const ctrl = Object.create(BaseCtrl);

    $scope.cancellationNumber = $stateParams.cancellationNumber;
    $scope.unfilteredActivities = [];
    $scope.cancellationService = CancellationService;

    ctrl.translateMessages = (cancellation) => {
        $scope.cancellationInfoMessageTitle = getInfoMessageTitle(cancellation);
        $scope.cancellationInfoMessageDesc = getInfoMessageDesc(cancellation);
    };

    function getInfoMessageTitle(cancellation) {
        if (cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Withdrawn').name) {
            return $filter('translate')('gateway.views.cancellation-detail.This cancellation has been withdrawn');
        } else if ((cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Bound').name)) {
            return $filter('translate')('gateway.views.cancellation-detail.This cancellation has been bound');
        }

        if (cancellation.isInsuredSource) {
            if (cancellation.isRefund) {
                return $filter('translate')('gateway.views.cancellation-detail.The cancellation refund amount has been calculated');
            }

            return $filter('translate')('gateway.views.cancellation-detail.The cancellation amount still owed has been calculated');
        }

        return $filter('translate')('gateway.views.cancellation-detail.This cancellation was initiated by the insurer');
    }

    function getInfoMessageDesc(cancellation) {
        if (cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Withdrawn').name) {
            return $filter('translate')('gateway.views.cancellation-detail.If you need to cancel the policy please create a new Cancellation');
        } else if ((cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Bound').name)) {
            return $filter('translate')('gateway.views.cancellation-detail.If you need to reinstate this policy please contact the underwriter');
        }

        if (cancellation.isInsuredSource) {
            if (cancellation.canWithdraw && cancellation.canBind) {
                return $filter('translate')('gateway.views.cancellation-detail.You can choose to Bind or Withdraw the Cancellation or add Activities, Notes, or Documents');
            }

            return $filter('translate')('gateway.views.cancellation-detail.You can choose to Withdraw the Cancellation or add Activities, Notes, or Documents');
        }

        if (UserInfoService.isAgent()) {
            return $filter('translate')('gateway.views.cancellation-detail.You cannot withdraw or bind the cancellation, but you can add activities, notes and documents to it.');
        }

        return $filter('translate')('gateway.views.cancellation-detail.You can bind the cancellation, but you cannot withdraw it.');
    }

    $scope.$watch('cancellation', () => {
        // When we navigate between quote detail tiles, ui-router instantiates controllers
        // with _new_ prototypically-inherited $scope. When we update cancellation on that scope from within,
        // it does not gets updated on a parent (because of prototypical inheritance).
        // Then when we navigate between states again the change is lost.
        // This propagates the change to the parent state.
        $scope.$parent.cancellation = $scope.cancellation;

        if (angular.isDefined($scope.cancellation)) {
            ctrl.translateMessages($scope.cancellation);
        }
    });

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'ActivityService', '$stateParams', 'UserService', '$filter', 'InsuranceSuiteMetadata', 'CancellationService', 'UserInfoService'];

export default fn;
